const draggable = "_35sd1uaspmm";

export { draggable };
import "./input.draggable.style.linaria.module.css";
//# sourceMappingURL=input.draggable.style.js.map
